import { InjectionToken } from "@angular/core";
import { HostSetupOptions } from "@loader-event-bus/app-event.model";

/** Structural host setup options delivered by the loader in the INIT handshake; immutable. */
export const HOST_SETUP = new InjectionToken<HostSetupOptions>("host.setup");
